// Fontes e monitores (saídas espectrais) do simulador 2D: valores padrão, migração do formato
// antigo e conversão para o payload do módulo Meep (module-2d/meep/util/main.py).
import { canvasToMeep, wavelengthToFrequency } from "./units";

export const DEFAULT_WAVELENGTH = 1.55; // µm

export const MONITOR_KINDS = [
  { value: "transmission", text: "Transmission spectrum (T)" },
  { value: "reflection", text: "Reflection spectrum (R)" },
  { value: "resonance", text: "Resonance (Harminv: f₀ and Q)" }
];

export const SOURCE_TYPES = [
  { value: "continuous", text: "Continuous wave (single wavelength)" },
  { value: "gaussian", text: "Gaussian pulse (broadband)" },
  { value: "gaussian_beam", text: "Gaussian beam (focused, directional)" }
];

export const defaultSource = ({ token, x, y, index }) => ({
  name: "Source " + index,
  token,
  class: "source",
  shape: "sphere",
  fill: "#FF0000",
  x, y, posX: x, posY: y,
  // Marcador no canvas (o tamanho físico da fonte é waveSize, em µm)
  width: 5, height: 5, radius: 8,
  sourceType: "continuous",
  component: "Ez",
  waveLength: DEFAULT_WAVELENGTH,
  frequency: wavelengthToFrequency(DEFAULT_WAVELENGTH),
  fwidth: 0,
  waveWidth: 0,
  waveSize: [0, 0],
  integrated: 0,
  beamWaist: 1,
  beamAngle: 0,
  beamFocus: [0, 0]
});

export const defaultMonitor = ({ token, x, y, index, wavelength }) => {
  const fcen = wavelengthToFrequency(wavelength || DEFAULT_WAVELENGTH);
  return {
    name: "Output " + index,
    token,
    class: "flux",
    kind: "transmission",
    shape: "monitor",
    fill: "#0000FF",
    x, y,
    width: 5, height: 5,
    length: 2,
    orientation: "vertical",
    fcen: Number(fcen.toFixed(4)),
    df: Number((0.4 * fcen).toFixed(4)),
    nfreq: 100
  };
};

// Monitores salvos antes desta versão (type: transmittance_spectrum, com três pontos em pixels
// convertidos de forma inconsistente) viram um monitor de transmissão na mesma posição do canvas.
export const migrateMonitor = (item) => {
  if (item.kind) return item;
  return {
    ...defaultMonitor({ token: item.token, x: item.x, y: item.y, index: "" }),
    name: item.name || "Output",
    fcen: Number(item.fcen) > 0 ? Number(item.fcen) : defaultMonitor({}).fcen,
    df: Number(item.df) > 0 ? Number(item.df) : defaultMonitor({}).df,
    nfreq: Number(item.nfreq) >= 2 ? Number(item.nfreq) : 100
  };
};

export const serializeMonitor = (state, monitor) => {
  const length = Math.abs(Number(monitor.length) || 0);
  let size = [0, 0];
  if (monitor.kind !== "resonance") {
    size = monitor.orientation === "horizontal" ? [length, 0] : [0, length];
  }
  return {
    kind: monitor.kind,
    name: monitor.name,
    center: canvasToMeep(state, Number(monitor.x), Number(monitor.y)),
    size,
    fcen: Number(monitor.fcen),
    df: Number(monitor.df),
    nfreq: Number(monitor.nfreq)
  };
};

// O marcador da fonte é um círculo do Konva: x,y já é o centro
export const serializeSource = (state, source) => ({
  ...source,
  position: canvasToMeep(state, Number(source.x), Number(source.y)),
  wavelength: Number(source.waveLength),
  waveSize: (source.waveSize || [0, 0]).map((value) => Math.abs(Number(value) || 0)),
  beamWaist: Number(source.beamWaist) || 0,
  beamAngle: Number(source.beamAngle) || 0
});
